const types = {
    SET_SCHEDULED_CASE_LIST_LOADING: 'SET_SCHEDULED_CASE_LIST_LOADING',
    SET_SCHEDULED_CASE_LIST: 'SET_SCHEDULED_CASE_LIST',
    SET_SCHEDULED_CASE_COUNT_LOADING: 'SET_SCHEDULED_CASE_COUNT_LOADING',
    SET_SCHEDULED_CASE_COUNT: 'SET_SCHEDULED_CASE_COUNT',
};

export default types;